import React, { useState } from 'react';
import Header from '../../../../Components/Header/Header';
import SideBar from '../../../../Components/SideBar/SideBar';
import './AddClient.scss';
import { useDispatch } from 'react-redux';
import { insertCLient } from '../../../../api/ClientApi/ClientApi.js';
import { useNavigate } from 'react-router-dom';
const AddClient = () => {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [image, setImage] = useState([]);
  const [url, setUrl] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      name: name,
      image: image,
      url: url,
    };
    dispatch(insertCLient(data));
    navigate('/wcmPartners');
    // console.log(data);
  };
  return (
    <div className="AddClientContainer">
      <SideBar />
      <div>
        <Header title={'Clients'} />
        <form onSubmit={handleSubmit} className="Wrapper">
          <h1>Add Clients</h1>
          <div className="inputContainer">
            <div className="nameInput">
              <span>Name</span>
              <input
                type="text"
                placeholder="Product Name"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="imgInput">
              <input
                type="file"
                name="brand-image"
                id=""
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            <div className="urlInput">
              <span>Url</span>
              <input
                type="text"
                placeholder="https://www.example.com"
                onChange={(e) => setUrl(e.target.value)}
              />
            </div>
          </div>
          <div className="buttonSave">
            <button>Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClient;
